export const API_X_SOURCE = 'portailvente_web';

export enum VAPI_X_VERSION {
    'V5' = '5',
}
export enum SAPIC_X_VERSION {
    'V5' = '5',
}
export enum SAPI_X_VERSION {
    'V4' = '4',
}
export enum PEV_X_VERSION {
    'V5' = '5',
}
